import React, { useCallback, useEffect, useState } from 'react';
import { useAtomValue } from 'jotai';
import { useStageAtoms } from '../../../../labelling-v2/components/stage-scope/hooks';
import useStage from '../../../providers/hooks/use-stage';
import { type StagePointerEventT } from '../../../providers/stage-provider';
import { getRectangleVertices } from '../rectangle/utils';
import { Vertex } from './../shape/vertex';
import { getTransformedRectDataPointsOnVertexMove, getTranslatedRectangleData } from './utils';
const Rectangle = () => {
  const {
    stage,
    multiSelectBox,
    setMultiSelectBox,
    referenceMultiSelectBox,
    setReferenceMultiSelectBox,
    selectedMultiBoxVertexType,
    setSelectedMultiBoxVertexType
  } = useStage();
  const {
    multiSelectEnabledAtom
  } = useStageAtoms();
  const isMultiSelectEnabled = useAtomValue(multiSelectEnabledAtom);
  const onDragStart = useCallback(() => {
    setReferenceMultiSelectBox(multiSelectBox ?? null);
  }, [multiSelectBox, setReferenceMultiSelectBox]);
  const onDrag = useCallback((stageEvent: StagePointerEventT) => {
    (() => {
      if (!referenceMultiSelectBox) {
        return;
      }
      const newRect = selectedMultiBoxVertexType ? getTransformedRectDataPointsOnVertexMove(referenceMultiSelectBox, stageEvent.detail.mousePos, selectedMultiBoxVertexType) : getTranslatedRectangleData(stageEvent.detail.deltaX, stageEvent.detail.deltaY, referenceMultiSelectBox);
      setMultiSelectBox(newRect);
    })();
  }, [selectedMultiBoxVertexType, setMultiSelectBox, referenceMultiSelectBox]);
  const onDragEnd = useCallback(
  // eslint-disable-next-line react-hooks/preserve-manual-memoization
  (stageEvent: StagePointerEventT) => {
    if (referenceMultiSelectBox) {
      const newRect = selectedMultiBoxVertexType ? getTransformedRectDataPointsOnVertexMove(referenceMultiSelectBox, stageEvent.detail.mousePos, selectedMultiBoxVertexType) : getTranslatedRectangleData(stageEvent.detail.deltaX, stageEvent.detail.deltaY, referenceMultiSelectBox);
      setMultiSelectBox(newRect);
      setReferenceMultiSelectBox(null);
      setSelectedMultiBoxVertexType(null);
    }
  }, [selectedMultiBoxVertexType, setMultiSelectBox, referenceMultiSelectBox, setReferenceMultiSelectBox]);
  useEffect(() => {
    if (!isMultiSelectEnabled && stage) {
      stage.addEventListener('dragstart', onDragStart);
      stage.addEventListener('drag', onDrag);
      stage.addEventListener('dragend', onDragEnd);
      return () => {
        stage.addEventListener('dragstart', onDragStart);
        stage.removeEventListener('drag', onDrag);
        stage.removeEventListener('dragend', onDragEnd);
      };
    }
  }, [isMultiSelectEnabled, onDrag, onDragEnd, stage, onDragStart]);
  if (!multiSelectBox) return null;
  const vertices = getRectangleVertices(multiSelectBox);
  return <g>
      <rect {...multiSelectBox} stroke="rgb(102,255,255)" strokeWidth="2" opacity="0.3" fill="B7FFFF" />
      {!isMultiSelectEnabled && vertices.map((vertex, index) => <Vertex key={`shape--vertex-${index}`} vertex={vertex} onSelect={() => setSelectedMultiBoxVertexType(vertex.type)} />)}
    </g>;
};
export default Rectangle;